import { Download, MoveRight, Trash2 } from "lucide-react"

import { Button, ButtonGroup } from "@/components/ui/button"

/** Preview route for Button. Not shipped — see routes/dev/primitives/index.tsx. */
export function ButtonPreviewRoute(): JSX.Element {
  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">Button</h1>
        <p className="mt-2 max-w-2xl text-body text-text-2">
          Four variants, three sizes. One primary per screen. Destructive is
          outlined red — never filled.
        </p>
      </header>

      <Section title="Variants">
        <Button variant="primary">Primary</Button>
        <Button variant="default">Default</Button>
        <Button variant="ghost">Ghost</Button>
        <Button variant="destructive">Destructive</Button>
      </Section>

      <Section title="Sizes">
        <Button size="sm">Small</Button>
        <Button size="md">Medium</Button>
        <Button size="lg">Large</Button>
      </Section>

      <Section title="With icons">
        <Button leadingIcon={<Download />}>Download PDF</Button>
        <Button variant="primary" trailingIcon={<MoveRight />}>
          Continue
        </Button>
        <Button variant="destructive" leadingIcon={<Trash2 />}>
          Remove
        </Button>
      </Section>

      <Section title="States">
        <Button loading loadingText="Sending…">
          Send to client
        </Button>
        <Button disabled>Disabled</Button>
        <Button variant="primary" disabled>
          Primary disabled
        </Button>
      </Section>

      <Section title="Block">
        <div className="w-80">
          <Button variant="primary" block>
            Sign in
          </Button>
        </div>
      </Section>

      <Section title="ButtonGroup">
        <ButtonGroup label="Disposition this finding">
          <Button variant="primary">Confirm</Button>
          <Button>Dismiss</Button>
          <Button>Send to SME</Button>
        </ButtonGroup>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
